import React, { useMemo } from 'react';
import Modal from 'react-modal';
import './index.css';

const UpdateNotificationModal = ({
      updateNotificationModalIsOpen,
      setUpdateNotificationModalIsOpen,
      resource,
      changedOrders,
      load,
      updateChangedOrdersCount,
      allAvailableOrders,
      state,
    }) => {

  const loadId = resource === 'load' ? 'loadId' : 'outboundLoadId';
  const allLoads = resource === 'load' ? state?.load?.loads : state?.outboundload?.loads;
  
  const updatedChangedOrders = useMemo(() =>
    changedOrders?.map(order => {
      const currentOrder = allAvailableOrders.find(o => o.poNumber === order.poNumber);
      const currentLoad = allLoads.find(load => load.id === currentOrder?.[loadId]);

      return {
        userName: order.userName,
        poNumber: order.poNumber,
        loadNumber: currentLoad?.loadNumber,
      };
    }), [allAvailableOrders, allLoads, changedOrders, loadId]
  );
  
  const closeModal = () => setUpdateNotificationModalIsOpen(false);

  const customStyle = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      minWidth: '330px',
      minHeight: '150px',
      maxWidth: '400px',
      maxHeight: '400px',
      borderRadius: '8px',
      padding: '0',
    },
  };

  const handleConfirm = () => {
    const url = resource === 'load' ? 'areaInboundEF' : 'areaOutboundEF';
    load(resource, url, 'withoutLoading');
    updateChangedOrdersCount(resource, '', 'empty');
    closeModal();
  };

  return (
    <Modal
        isOpen={updateNotificationModalIsOpen}
        onRequestClose={closeModal}
        style={customStyle}
        ariaHideApp={false}
        >
        <div className='apply-changes_modal__container'>
            <div className='apply-changes__title-container'>
              <div className='apply-changes_modal__x-btn' onClick={closeModal}>X</div>
              <div className='apply-changes__title'>Apply Changes</div>
            </div>
            <div className='apply-changes_modal__text'>
              {changedOrders?.length < 1 ? 
                <div>No changes are available</div> : null
              }
              {updatedChangedOrders?.length ? 
                  updatedChangedOrders.map(order => (
                    <div className='apply-changes__data'>
                      <div className='apply-changes-data-row'>
                        <div className='apply-changes-data__title'>User Name: </div>
                        <div>{order.userName} </div>
                      </div>
                      <div className='apply-changes-data-row'>
                        <div className='apply-changes-data__title'>Updates: </div>
                        <div>PO# {order.poNumber} </div>
                      </div>
                      <div className='apply-changes-data-row'>
                        <div className='apply-changes-data__title'>Load#: </div>
                        <div>{order.loadNumber} </div>
                      </div>
                    </div>
                  )) : null
                }
            </div>
            <div className='apply-changes-btn__container'>
              {changedOrders?.length > 0 ? <div className='apply-changes_modal__btn-confirm' onClick={handleConfirm}>Confirm</div> : null}
              <div className='apply-changes_modal__btn-cancel' onClick={closeModal}>Cancel</div>
            </div>
        </div>  
    </Modal>
  );
};

export default UpdateNotificationModal;

